import { ConfirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { useDocumentOverviewApi } from '~/components/ui/document/dialogs/documentOverviewDialog/useDocumentOverviewApi';
import { DocumentOverviewContainer } from '~/components/ui/document/DocumentOverviewContainer';
import { useDocumentsUrlParams } from '~/components/ui/tables/ag/documentsTable/useDocumentsUrlParams';
import { useDocumentsUrlParamsPortfolio } from '~/components/ui/tables/ag/documentsTable/useDocumentsUrlParamsPortfolio';

export type DialogDocumentOverviewProps = {
  fundName?: string;
  source?: string;
  portfolioCompanyId?: string;
};

export const DialogDocumentOverview = ({
  fundName,
  source = 'fundDocuments',
}: DialogDocumentOverviewProps) => {
  const {
    isDocumentOverviewDialogVisible,
    activeDocumentId,
    activeDocumentName,
    hideDocumentOverview,
  } =
    source === 'fundDocuments'
      ? useDocumentsUrlParams()
      : useDocumentsUrlParamsPortfolio();

  const { loadDocument, documentMeta } = useDocumentOverviewApi({
    documentId: activeDocumentId,
  });

  return (
    <>
      <Dialog
        onHide={() => {
          hideDocumentOverview();
        }}
        onShow={() => {
          loadDocument();
        }}
        header={
          <div>
            <span
              style={{
                fontSize: '14px',
                display: 'block',
                fontWeight: 'normal',
                color: 'var(--bq-color-gray)',
              }}
            >
              Document Overview
            </span>
            {fundName ? (
              <>
                <span
                  style={{ fontSize: '16px', color: 'var(--bq-color-gray)' }}
                >
                  {fundName}
                </span>
                <span style={{ fontSize: '16px' }}>
                  {' '}
                  / {activeDocumentName}
                </span>
              </>
            ) : (
              <span style={{ fontSize: '16px' }}> {activeDocumentName}</span>
            )}
          </div>
        }
        style={{
          width: '100vw',
          height: '100vh',
          maxHeight: '100vh',
          padding: '0',
        }}
        visible={isDocumentOverviewDialogVisible}
        pt={{
          content: { style: { height: '100%', padding: '0' } },
          header: { style: { padding: '0.5rem 1rem' } },
        }}
      >
        <DocumentOverviewContainer
          documentId={activeDocumentId}
          source={source}
          portfolioCompanyId={documentMeta?.portfolioCompanyId}
        />
      </Dialog>
      <ConfirmDialog />
    </>
  );
};
